const DATA_EXPORT_SCHEDULER = 'dataExportScheduler';
const REPORT_LEVEL_FILTER = 'reportLevelFilter';
const WHAT_IM_DOING_FILTER = 'whatImDoingFilter';

import commonStrings from 'resources/commonStrings';

const filterIdentifiers = [REPORT_LEVEL_FILTER, WHAT_IM_DOING_FILTER];

/**
 * This function adds the initial state for a sidebar accordion to the supplied map
 * @param identifier This must be one of the allowabe identifiers defined within this file
 * @param accordionsMap The map to which the initial state will be added
 * @param accordionSpecificState Specific starting state for the accordion item
 * @returns {*} Map whose key for the supplied identifier holds an object specifying the state i.e.
 * Map(
 *          [key: dataExportScheduler,
 *           value: {
 *                      displayText: 'Data Export Scheduler',
 *                      itemState: {
 *                          isExpanded: false,
 *                          exportHistory: [...]
 *                          }
 *                   }
 *           ]
 * );
 */
const addAccordionState = (identifier, accordionsMap, accordionSpecificState) => {
  const initialState = Object.assign({ isExpanded: false }, accordionSpecificState);

  switch (identifier) {
    case DATA_EXPORT_SCHEDULER: {
      accordionsMap.set(DATA_EXPORT_SCHEDULER, {
        itemState: initialState,
        displayText: commonStrings.accordionTitle.dataExportScheduler,
      });
      break;
    }
    case REPORT_LEVEL_FILTER: {
      accordionsMap.set(REPORT_LEVEL_FILTER, {
        itemState: initialState,
        displayText: commonStrings.accordionTitle.reportLevel,
      });
      break;
    }
    case WHAT_IM_DOING_FILTER: {
      accordionsMap.set(WHAT_IM_DOING_FILTER, {
        itemState: initialState,
        displayText: commonStrings.accordionTitle.whatImDoing,
      });
      break;
    }
    default: {
      console.warn(`An unknown accordion type '${identifier}' was specified, it cannot be created`);
      break;
    }
  }

  return accordionsMap;
};

export default {
  DATA_EXPORT_SCHEDULER,
  REPORT_LEVEL_FILTER,
  WHAT_IM_DOING_FILTER,
  filterIdentifiers,
  addAccordionState,
};
